import httpClient from "../../../services/httpClient";

const submitReferralAsync = async (submission, selectedOfficeId, username, loggedInLawFirmName) => {
    
    const domain = window.location.host;
    const configs = require('../../../config.json');
    const config = configs.filter(c => c.Domain.toLowerCase() === domain.toLowerCase())[0];
    const endpoint = config.FunctionAppUrl + `/createlawfirmreferral`;

    httpClient.defaults.headers.common['Office-Id'] = selectedOfficeId ?? -1;
    httpClient.defaults.headers.common['Users-Law-Firm'] = loggedInLawFirmName;
    httpClient.defaults.headers.common['Username'] = username;

    return await httpClient.post(endpoint, submission)
};

const referralService = { 
    submitReferralAsync
};

export default referralService;